var Sticky = require( 'sticky-js' );

document.addEventListener( 'DOMContentLoaded', function () {
	var button = document.querySelector( '.sticky-button' );

	if ( ! button ) {
		return;
	}

	function calculate_window_vertical_middle() {
		return parseInt( ( window.innerHeight - button.offsetHeight ) / 2, 10 );
	}

	function update_sticky_button_element() {
		button.setAttribute( 'data-margin-top', calculate_window_vertical_middle() );
	}

	update_sticky_button_element();

	var sticky = new Sticky( '.sticky-button' );

	function update_sticky_button_position() {
		// console.log(sticky);
		update_sticky_button_element();
		sticky.destroy();
		sticky = new Sticky( '.sticky-button' );
	}

	window.onresize = update_sticky_button_position;
}, false );
